export default {
  search: 'Buscar',
  rolesForUser: 'Papéis para o usuário:',
  save: 'Salvar',
  warning: 'Aviso',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  processing: 'Processando...',
  close: 'Fechar',
  name: 'Nome',
  lastname: 'Sobrenome',
  email: 'E-mail',
  roles: 'Papéis',
  role: 'Papel',
  description: 'Descrição',
  modelAccessManager: 'Pode gerenciar o acesso ao modelo para outros usuários',
  ekrmManager: 'Pode gerenciar os Modelos de Referência de Conhecimento Especializado (EKRM)',
  dataUploader: 'Pode fazer upload de dados para a Configuração do Modelo',
  onlyShowModelReport: 'Mostrar apenas Relatório do Modelo na navegação',
  externalUser: 'Usuário externo: pode ver apenas planos que criou',
  rolesUpdated: 'Papéis atualizados com sucesso',
  failedToUpdateRoles: 'Erro ao atualizar os papéis. Por favor, tente novamente.',
  errorUpdatingRoles: 'Ocorreu um erro ao atualizar os papéis:'
}
